import { FavouriteConditionValue } from 'app/types-shared';
import { ConditionValuesOperator, FilterTypes } from 'app/components/filters/types';
import { numberFieldOperators } from 'app/components/filters/filters-panel/constants';
import { createFieldOptionType } from 'app/area/filters/favourite-definition/create-field-option-type';

export const createNumberFieldValue = (values: FavouriteConditionValue[]) => {
  return values
    .map(item => {

      const newItem = {
        [ConditionValuesOperator.equal]: item.number,
        [ConditionValuesOperator.largerOrEqual]: item.number + numberFieldOperators.largerOrEqual,
        [ConditionValuesOperator.lessOrEqual]: item.number + numberFieldOperators.less,
        [ConditionValuesOperator.between]: item.number + numberFieldOperators.between + item.number2,
        [ConditionValuesOperator.or]: item.number
      };

      return String(item.operator && newItem[item.operator.v]);
    })
    .join();
};

export const createInitialNumberFieldConditions = (favouriteConditionValue: FavouriteConditionValue,
  conditionValues: FavouriteConditionValue[]) => {

  const conditionValuesOperators = {
    [ConditionValuesOperator.empty]: { type: createFieldOptionType(conditionValues)[0] }
  };

  const defaultValue = { value: createNumberFieldValue(conditionValues) };
  const optionTypeOperator = conditionValues[0] && conditionValues[0].operator;
  const optionTypeValue = (optionTypeOperator && conditionValuesOperators[optionTypeOperator.v]);

  return {
    [FilterTypes.NumberField]: conditionValues && (optionTypeValue || defaultValue)
  };
};
